import { render } from "./SimulationsModule.vue?vue&type=template&id=08fc4b2f&ts=true"
import script from "./SimulationsModule.vue?vue&type=script&lang=ts"
export * from "./SimulationsModule.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__